<script setup>
import WebsiteVariantTable from '@frontJs/components/tables/projectManagement/customers/WebsiteVariantTable.vue';
import TenantReportWebsiteVariantTable from '@frontJs/components/tables/projectManagement/customers/tenantReports/WebsiteVariantTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant } = defineProps({
    tenant: {
        type: Object,
        required: false,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Sites - Clients - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle :tenant-name="tenant ? tenant.name : undefined">
        Gestion de projet - Clients - Sites
    </PageTitle>

    <WebsiteVariantTable v-if="tenant" :tenant="tenant" />

    <TabLayout
        v-else
        :tabs="{
            perCustomer: {
                title: 'Par client',
                content: h(TenantReportWebsiteVariantTable),
            },
            all: {
                title: 'Tous',
                content: h(WebsiteVariantTable, { all: true }),
            },
        }"
    />
</template>
